import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class ComponentPageTitle {
	_title = '';

	_flagaux:boolean = true;

	get title(): string { return this._title };
	get flagaux():boolean { return this._flagaux };

	set title(title: string) {
		this._title = title;
		if (title !== '') {
			title = `${title} | `;
		}
		this.bodyTitle.setTitle(`${title}`);
	}

	set flagaux(flag: boolean) {
		this._flagaux = flag;
	}

	constructor(private bodyTitle: Title) { }
}